
function init()
{
    let $home = $('.home');

    if ( !$home.length ) {

        return;
    }
    // $('.trending').removeClass('pt-5 mt-5');

    // $('.bg-b-g').removeClass('bg-b-g').addClass('bg-b-w');

   let activeSlide = $("#home-slider" ).find(".active");

}

$(() => {
    init();
});